import { memo } from 'react'

const IconMenu = ({
  fill,
  width,
  height,
}: {
  fill: string
  width: string
  height: string
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M3.75 12C3.75 11.5858 4.08579 11.25 4.5 11.25H19.5C19.9142 11.25 20.25 11.5858 20.25 12C20.25 12.4142 19.9142 12.75 19.5 12.75H4.5C4.08579 12.75 3.75 12.4142 3.75 12Z'
        fill={fill}
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M3.75 5.5C3.75 5.08579 4.08579 4.75 4.5 4.75H19.5C19.9142 4.75 20.25 5.08579 20.25 5.5C20.25 5.91421 19.9142 6.25 19.5 6.25H4.5C4.08579 6.25 3.75 5.91421 3.75 5.5Z'
        fill={fill}
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M3.75 18.5C3.75 18.0858 4.08579 17.75 4.5 17.75H19.5C19.9142 17.75 20.25 18.0858 20.25 18.5C20.25 18.9142 19.9142 19.25 19.5 19.25H4.5C4.08579 19.25 3.75 18.9142 3.75 18.5Z'
        fill={fill}
      />
    </svg>
  )
}

export default memo(IconMenu)
